export const dataConfigType = {
  LIVEDATA: 'LIVEDATA',
  TESTDATA1: 'TESTDATA1',
  TESTDATA2: 'TESTDATA2'
};

// Configure LIVEDATA or TESTDATA1 or TESTDATA2:
const currentDataConfigType = dataConfigType.LIVEDATA;

export const getDataConfigType = (logToConsole = false) => {
  if (logToConsole) {
    console.log('Data configured as', currentDataConfigType);
  }
  return currentDataConfigType;
};
